export const DEFAULT_CURRENCY = 'EUR';

const SUPPORTED_CURRENCIES = new Set([
  'ARS',
  'BRL',
  'CLP',
  'COP',
  'EUR',
  'GTQ',
  'MXN',
  'NIO',
  'PEN',
  'USD',
]);

export function resolveCurrency(currency?: string | null): string {
  if (currency && SUPPORTED_CURRENCIES.has(currency)) {
    return currency;
  }
  return DEFAULT_CURRENCY;
}

export function formatMoney(
  value: number | string | null | undefined,
  opts: {
    currency: string;
    locale: string;
    minimumFractionDigits?: number;
    maximumFractionDigits?: number;
  },
): string {
  const num = typeof value === 'string' ? parseFloat(value) : value;
  const safeNum = num == null || Number.isNaN(num) ? 0 : num;
  const currency = resolveCurrency(opts.currency);
  const fractionOpts =
    opts.minimumFractionDigits != null || opts.maximumFractionDigits != null
      ? {
          ...(opts.minimumFractionDigits != null
            ? { minimumFractionDigits: opts.minimumFractionDigits }
            : {}),
          ...(opts.maximumFractionDigits != null
            ? { maximumFractionDigits: opts.maximumFractionDigits }
            : {}),
        }
      : {};

  try {
    return new Intl.NumberFormat(opts.locale, {
      style: 'currency',
      currency,
      currencyDisplay: 'narrowSymbol',
      ...fractionOpts,
    }).format(safeNum);
  } catch (error) {
    console.warn('[currency] formatMoney fallback to EUR:', error);
    return new Intl.NumberFormat(opts.locale, {
      style: 'currency',
      currency: DEFAULT_CURRENCY,
      currencyDisplay: 'narrowSymbol',
      ...fractionOpts,
    }).format(safeNum);
  }
}

export function getCurrencySymbol(currency: string, locale: string): string {
  const resolved = resolveCurrency(currency);

  try {
    const parts = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: resolved,
      currencyDisplay: 'narrowSymbol',
    }).formatToParts(0);
    return parts.find((part) => part.type === 'currency')?.value ?? resolved;
  } catch (error) {
    console.warn('[currency] getCurrencySymbol fallback to EUR:', error);
    const parts = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: DEFAULT_CURRENCY,
      currencyDisplay: 'narrowSymbol',
    }).formatToParts(0);
    return parts.find((part) => part.type === 'currency')?.value ?? DEFAULT_CURRENCY;
  }
}

/** Formato numérico Excel para columnas `currency` (símbolo dinámico). */
export function getExcelCurrencyNumberFormat(symbol: string): string {
  const safeSymbol = symbol.replace(/"/g, '');
  return `#,##0.00 "${safeSymbol}"`;
}
